(function (root, factory) {
  var api = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.NulelaBuyingOptions = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  var offerListenerBound = false;

  function normaliseMoneyLabel(label) {
    return String(label || '').replace(/<[^>]*>/g, '').trim();
  }

  function getInitialPurchaseState() {
    return {
      tierIndex: 1,
      subscribed: false,
    };
  }

  function getGiftUnlockState(bottleCount) {
    return [1, 3, 5].map(function (requiredBottles) {
      return bottleCount >= requiredBottles;
    });
  }

  function uniqueStrings(values) {
    return (values || []).reduce(function (unique, value) {
      var normalised = String(value || '').trim();
      if (normalised && unique.indexOf(normalised) === -1) unique.push(normalised);
      return unique;
    }, []);
  }

  function buildSubscriptionCopy(tier) {
    var bottleCount = Number(tier.bottleCount || 1);
    var intervalCount = Number(tier.intervalCount || bottleCount || 1);
    var bottleLabel = bottleCount === 1 ? 'bottle' : 'bottles';
    var monthLabel = intervalCount === 1 ? 'month' : 'months';

    return {
      firstDelivery: 'First delivery: ' + bottleCount + ' ' + bottleLabel + ' today',
      futureDeliveries: 'Future deliveries: ' + bottleCount + ' ' + bottleLabel + ' every ' + intervalCount + ' ' + monthLabel,
      monthlyEquivalent: 'Recurring price shown for your selected supply · Skip or cancel anytime',
    };
  }

  function buildGiftItems(tier, parentKey) {
    var bottleCount = Number(tier.bottleCount || 1);
    var unlockedCount = bottleCount >= 5 ? 3 : bottleCount >= 3 ? 2 : 1;

    return uniqueStrings(tier.giftVariantIds).slice(0, unlockedCount).map(function (giftVariantId) {
      return {
        id: giftVariantId,
        quantity: 1,
        properties: {
          _nulela_gift: 'true',
          _nulela_parent_variant: String(parentKey),
          _nulela_gift_tier: String(bottleCount),
        },
      };
    });
  }

  function buildCartItems(selection, tier) {
    var physicalItem = {
      id: String(selection.variantId),
      quantity: 1,
    };

    if (selection.sellingPlanId) physicalItem.selling_plan = String(selection.sellingPlanId);

    return [physicalItem].concat(buildGiftItems(tier, selection.variantId));
  }

  function buildAddRequest(selection, tier, rootPath, sectionsUrl) {
    var localeRoot = String(rootPath || '/').replace(/\/$/, '');
    return {
      endpoint: localeRoot + '/cart/add.js',
      body: {
        items: buildCartItems(selection, tier),
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: sectionsUrl || '/',
      },
    };
  }

  function resolvePurchaseSelection(tier, subscribed) {
    var allocation = tier.allocation;
    var subscriptionAvailable = Boolean(allocation && allocation.sellingPlanId);

    if (subscribed && subscriptionAvailable) {
      return {
        variantId: tier.variantId,
        price: allocation.price,
        compareAtPrice: tier.oneTimePrice,
        sellingPlanId: allocation.sellingPlanId,
        subscriptionAvailable: true,
      };
    }

    return {
      variantId: tier.variantId,
      price: tier.oneTimePrice,
      compareAtPrice: tier.compareAtPrice,
      sellingPlanId: '',
      subscriptionAvailable: subscriptionAvailable,
    };
  }

  function buildCartFields(selection) {
    var fields = {
      id: String(selection.variantId),
      quantity: '1',
    };

    if (selection.sellingPlanId) {
      fields.selling_plan = String(selection.sellingPlanId);
    }

    return fields;
  }

  function buildTierDisplay(tier, subscribed) {
    var selection = resolvePurchaseSelection(tier, subscribed);
    var savings = Math.max(0, selection.compareAtPrice - selection.price);
    var savingsPercentage = selection.compareAtPrice > 0
      ? Math.round(savings * 100 / selection.compareAtPrice)
      : 0;

    return {
      price: selection.price,
      compareAtPrice: selection.compareAtPrice,
      savings: savings,
      savingsPercentage: savingsPercentage,
    };
  }

  function readTier(element) {
    var sellingPlanId = element.getAttribute('data-selling-plan-id') || '';
    var subscriptionPrice = Number(element.getAttribute('data-subscription-price') || 0);

    return {
      variantId: element.getAttribute('data-variant-id') || '',
      oneTimePrice: Number(element.getAttribute('data-one-time-price') || 0),
      compareAtPrice: Number(element.getAttribute('data-compare-price') || 0),
      available: element.getAttribute('data-available') !== 'false',
      bottleCount: Number(element.getAttribute('data-bottle-count') || 1),
      intervalCount: Number(element.getAttribute('data-interval-count') || 1),
      giftVariantIds: uniqueStrings((element.getAttribute('data-gift-variant-ids') || '').split(',')),
      allocation: sellingPlanId && subscriptionPrice > 0
        ? { sellingPlanId: sellingPlanId, price: subscriptionPrice }
        : null,
    };
  }

  function initRoot(rootElement) {
    if (rootElement.getAttribute('data-nbo-initialized') === 'true') return;
    rootElement.setAttribute('data-nbo-initialized', 'true');

    var form = rootElement.querySelector('[data-nbo-form]');
    var tiers = Array.prototype.slice.call(rootElement.querySelectorAll('[data-nbo-tier]'));
    var subscribe = rootElement.querySelector('[data-nbo-subscribe]');
    var variantInput = rootElement.querySelector('[data-nbo-variant-id]');
    var sellingPlanInput = rootElement.querySelector('[data-nbo-selling-plan]');
    var errorElement = rootElement.querySelector('[data-nbo-error]');
    var button = rootElement.querySelector('[data-nbo-atc]');
    var gifts = Array.prototype.slice.call(rootElement.querySelectorAll('[data-nbo-gift]'));
    var firstDelivery = rootElement.querySelector('[data-nbo-first-delivery]');
    var futureDeliveries = rootElement.querySelector('[data-nbo-future-deliveries]');
    var monthlyEquivalent = rootElement.querySelector('[data-nbo-monthly-equivalent]');
    var currentPrice = rootElement.querySelector('[data-nbo-current-price]');
    var currentCompare = rootElement.querySelector('[data-nbo-current-compare]');
    var currentSale = rootElement.querySelector('[data-nbo-current-sale]');
    var submitting = false;

    if (!form || !tiers.length || !subscribe || !variantInput || !sellingPlanInput || !button) return;

    function selectedTier() {
      return tiers.find(function (tier) {
        var radio = tier.querySelector('[data-nbo-radio]');
        return radio && radio.checked;
      }) || tiers[0];
    }

    function showError(message) {
      if (!errorElement) return;
      errorElement.textContent = message || '';
      errorElement.hidden = !message;
    }

    function updateTierDisplay(tier) {
      var tierData = readTier(tier);
      var useSubscription = subscribe.checked && Boolean(tierData.allocation);
      var price = tier.querySelector('[data-nbo-price]');
      var compare = tier.querySelector('[data-nbo-compare]');
      var save = tier.querySelector('[data-nbo-save]');
      var savePercentage = save && save.querySelector('[data-nbo-save-percentage]');
      var display = buildTierDisplay(tierData, useSubscription);

      if (price) {
        price.textContent = useSubscription
          ? normaliseMoneyLabel(tier.getAttribute('data-subscription-price-label'))
          : normaliseMoneyLabel(tier.getAttribute('data-one-time-price-label'));
      }

      if (compare) {
        var compareLabel = useSubscription
          ? tier.getAttribute('data-one-time-price-label')
          : tier.getAttribute('data-compare-price-label');
        compare.textContent = normaliseMoneyLabel(compareLabel);
        compare.hidden = !compareLabel;
      }

      if (save) {
        if (savePercentage && display.savingsPercentage > 0) {
          savePercentage.textContent = display.savingsPercentage + '%';
        }
        save.hidden = !savePercentage || display.savingsPercentage <= 0;
      }
    }

    function updateCurrentPrice(tier) {
      var tierData = readTier(tier);
      var useSubscription = subscribe.checked && Boolean(tierData.allocation);
      var priceLabel = normaliseMoneyLabel(useSubscription
        ? tier.getAttribute('data-subscription-price-label')
        : tier.getAttribute('data-one-time-price-label'));
      var compareLabel = normaliseMoneyLabel(useSubscription
        ? tier.getAttribute('data-one-time-price-label')
        : tier.getAttribute('data-compare-price-label'));

      if (currentPrice) currentPrice.textContent = priceLabel;
      rootElement.querySelectorAll('[data-nbo-current-price]').forEach(function (element) { element.textContent = priceLabel; });
      rootElement.querySelectorAll('[data-nbo-current-compare]').forEach(function (element) {
        element.textContent = compareLabel;
        element.hidden = !compareLabel;
      });
      if (currentCompare) {
        currentCompare.textContent = compareLabel;
        currentCompare.hidden = !compareLabel;
      }
      if (currentSale) currentSale.hidden = !compareLabel;
    }

    function applySelection() {
      var tier = selectedTier();
      var tierData = readTier(tier);
      var selection = resolvePurchaseSelection(tierData, subscribe.checked);
      var bottleCount = Number(tier.getAttribute('data-bottle-count') || 1);
      var giftUnlockState = getGiftUnlockState(bottleCount);
      var deliveryCopy = buildSubscriptionCopy(tierData);

      if (subscribe.checked && !selection.subscriptionAvailable) {
        subscribe.checked = false;
        selection = resolvePurchaseSelection(tierData, false);
        showError(subscribe.getAttribute('data-unavailable-message'));
      } else {
        showError('');
      }

      tiers.forEach(function (item) {
        item.classList.toggle('is-selected', item === tier);
        updateTierDisplay(item);
      });
      updateCurrentPrice(tier);

      gifts.forEach(function (gift, index) {
        var unlocked = Boolean(giftUnlockState[index]);
        gift.classList.toggle('is-locked', !unlocked);
        gift.setAttribute('aria-label', unlocked
          ? gift.getAttribute('data-unlocked-label')
          : 'Locked');
      });

      variantInput.value = selection.variantId;
      sellingPlanInput.value = selection.sellingPlanId;
      sellingPlanInput.disabled = !selection.sellingPlanId;
      button.disabled = !tierData.available || submitting;
      button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
      rootElement.classList.toggle('is-subscribed', Boolean(selection.sellingPlanId));
      if (firstDelivery) firstDelivery.textContent = deliveryCopy.firstDelivery;
      if (futureDeliveries) futureDeliveries.textContent = deliveryCopy.futureDeliveries;
      if (monthlyEquivalent) monthlyEquivalent.textContent = deliveryCopy.monthlyEquivalent;
      announcePurchaseState(tier, 'purchase-selection');
    }

    function syncKachingSelection() {
      var widget = rootElement.querySelector('kaching-bundle[data-initialized="true"]');
      if (!widget) return false;
      var kachingRadios = Array.prototype.slice.call(widget.querySelectorAll('input[type="radio"]'));
      var selectedIndex = kachingRadios.findIndex(function (radio) { return radio.checked; });
      if (selectedIndex < 0 || !tiers[selectedIndex]) return false;

      rootElement.setAttribute('data-nbo-kaching-ready', 'true');
      var changed = false;
      tiers.forEach(function (tier, index) {
        var radio = tier.querySelector('[data-nbo-radio]');
        if (!radio) return;
        var shouldBeChecked = index === selectedIndex;
        if (radio.checked !== shouldBeChecked) changed = true;
        radio.checked = shouldBeChecked;
      });
      if (changed) applySelection();
      return true;
    }

    function announcePurchaseState(tier, source) {
      var tierData = readTier(tier);
      var useSubscription = subscribe.checked && Boolean(tierData.allocation);
      var selection = resolvePurchaseSelection(tierData, useSubscription);
      var priceLabel = normaliseMoneyLabel(useSubscription
        ? tier.getAttribute('data-subscription-price-label')
        : tier.getAttribute('data-one-time-price-label'));
      var compareAtPriceLabel = normaliseMoneyLabel(useSubscription
        ? tier.getAttribute('data-one-time-price-label')
        : tier.getAttribute('data-compare-price-label'));

      rootElement.dispatchEvent(new CustomEvent('nulela:purchase-state', {
        bubbles: true,
        detail: {
          source: source,
          variantId: selection.variantId,
          sellingPlanId: selection.sellingPlanId,
          price: selection.price,
          compareAtPrice: selection.compareAtPrice,
          priceLabel: priceLabel,
          compareAtPriceLabel: compareAtPriceLabel,
          available: tierData.available && !submitting,
        },
      }));
    }

    rootElement.nulelaSelectOffer = function (detail) {
      var requestedTier = detail && detail.tier;
      var validOfferTiers = ['one', 'three', 'five', 'subscribe'];
      var unavailable = {
        success: false,
        message: 'This offer is currently unavailable. Please choose another option.',
      };
      if (validOfferTiers.indexOf(requestedTier) === -1) return unavailable;

      var targetTier = selectedTier();
      if (requestedTier === 'subscribe') {
        if (subscribe.disabled) return unavailable;
        var currentTierData = readTier(targetTier);
        if (!currentTierData.available || !currentTierData.allocation) return unavailable;
      } else {
        targetTier = tiers.find(function (tier) {
          return tier.getAttribute('data-offer-tier') === requestedTier
            && readTier(tier).available;
        });
      }

      if (!targetTier) return unavailable;
      tiers.forEach(function (tier) {
        var radio = tier.querySelector('[data-nbo-radio]');
        if (radio) radio.checked = tier === targetTier;
      });
      subscribe.checked = requestedTier === 'subscribe';
      applySelection();
      announcePurchaseState(targetTier, 'mystery-offer');

      var reduceMotion = typeof window !== 'undefined'
        && typeof window.matchMedia === 'function'
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rootElement.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      return { success: true, message: '' };
    };

    tiers.forEach(function (tier) {
      var radio = tier.querySelector('[data-nbo-radio]');
      if (!radio) return;
      radio.addEventListener('change', applySelection);
    });

    subscribe.addEventListener('change', applySelection);

    rootElement.addEventListener('change', function (event) {
      if (!event.target.closest || !event.target.closest('kaching-bundle')) return;
      syncKachingSelection();
    });

    if (typeof MutationObserver === 'function') {
      var kachingObserver = new MutationObserver(syncKachingSelection);
      kachingObserver.observe(rootElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-initialized'] });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submitting) return;
      applySelection();
      if (button.disabled) {
        showError('This supply option is currently unavailable. Please choose another option.');
        return;
      }

      var originalMarkup = button.innerHTML;
      submitting = true;
      button.disabled = true;
      announcePurchaseState(selectedTier(), 'cart-loading');
      button.textContent = button.getAttribute('data-loading-label');

      var tierData = readTier(selectedTier());
      var selection = resolvePurchaseSelection(tierData, subscribe.checked);
      var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var request = buildAddRequest(selection, tierData, rootPath, window.location.pathname);

      fetch(request.endpoint, {
        method: 'POST',
        body: JSON.stringify(request.body),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) {
              throw new Error(
                payload.description || payload.message || form.getAttribute('data-gift-error-message') || 'Unable to add this item.',
              );
            }
            return payload;
          });
        })
        .then(function (payload) {
          button.textContent = button.getAttribute('data-success-label');
          if (payload.sections && window.NulelaCartDrawer && typeof window.NulelaCartDrawer.replaceSections === 'function') {
            window.NulelaCartDrawer.replaceSections(payload.sections, true);
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
          }
          setTimeout(function () {
            submitting = false;
            button.innerHTML = originalMarkup;
            applySelection();
          }, 1200);
        })
        .catch(function (error) {
          submitting = false;
          button.innerHTML = originalMarkup;
          applySelection();
          showError(error.message);
        });
    });

    var initialState = getInitialPurchaseState();
    var initialTier = tiers[initialState.tierIndex];
    var initialRadio = initialTier && initialTier.querySelector('[data-nbo-radio]');
    if (!initialRadio || initialRadio.disabled) {
      initialRadio = tiers.map(function (tier) { return tier.querySelector('[data-nbo-radio]'); })
        .find(function (radio) { return radio && !radio.disabled; });
    }
    tiers.forEach(function (tier) {
      var radio = tier.querySelector('[data-nbo-radio]');
      if (radio) radio.checked = radio === initialRadio;
    });
    if (!subscribe.disabled) subscribe.checked = initialState.subscribed;

    applySelection();
    syncKachingSelection();
  }

  function initAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-nulela-buying-options]'),
      initRoot,
    );

    if (!offerListenerBound) {
      document.addEventListener('nulela:select-offer', function (event) {
        var result = {
          success: false,
          message: 'This offer is currently unavailable. Please choose another option.',
        };
        Array.prototype.forEach.call(
          document.querySelectorAll('[data-nulela-buying-options]'),
          function (rootElement) {
            if (!result.success && typeof rootElement.nulelaSelectOffer === 'function') {
              result = rootElement.nulelaSelectOffer(event.detail);
            }
          },
        );
        document.dispatchEvent(new CustomEvent('nulela:offer-selection-result', {
          detail: {
            tier: event.detail && event.detail.tier,
            success: Boolean(result.success),
            message: result.message || '',
          },
        }));
      });
      offerListenerBound = true;
    }
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  }

  return {
    normaliseMoneyLabel: normaliseMoneyLabel,
    getInitialPurchaseState: getInitialPurchaseState,
    getGiftUnlockState: getGiftUnlockState,
    buildSubscriptionCopy: buildSubscriptionCopy,
    buildGiftItems: buildGiftItems,
    buildCartItems: buildCartItems,
    buildAddRequest: buildAddRequest,
    resolvePurchaseSelection: resolvePurchaseSelection,
    buildCartFields: buildCartFields,
    buildTierDisplay: buildTierDisplay,
    readTier: readTier,
    initRoot: initRoot,
    initAll: initAll,
  };
});
